var _rect, _path, _rect2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAppleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 34,
    viewBox: "0 0 34 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 33,
    rx: 16.5,
    fill: "#F6F6F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5142 21.4689C23.27 22.0279 22.981 22.5424 22.6461 23.0155C22.1897 23.6604 21.8159 24.1068 21.5279 24.3547C21.0814 24.7616 20.603 24.97 20.0908 24.9818C19.723 24.9818 19.2795 24.8781 18.7633 24.6678C18.2453 24.4584 17.7693 24.3547 17.3341 24.3547C16.8776 24.3547 16.3881 24.4584 15.8645 24.6678C15.34 24.8781 14.9176 24.9878 14.5946 24.9986C14.1033 25.0194 13.6137 24.8051 13.1249 24.3547C12.813 24.0851 12.4228 23.6229 11.9554 22.9681C11.4539 22.2688 11.0416 21.458 10.7186 20.5336C10.3726 19.5351 10.1992 18.5682 10.1992 17.6321C10.1992 16.5599 10.433 15.6351 10.9013 14.8601C11.2694 14.2376 11.759 13.7465 12.3719 13.386C12.9847 13.0256 13.6469 12.8419 14.3599 12.8301C14.7501 12.8301 15.2618 12.9497 15.8976 13.1848C16.5317 13.4206 16.9388 13.5402 17.1173 13.5402C17.2508 13.5402 17.703 13.4004 18.4697 13.1216C19.1948 12.863 19.8067 12.7559 20.308 12.7981C21.6664 12.9067 22.687 13.4374 23.3657 14.3934C22.1508 15.1229 21.5498 16.1446 21.5618 17.4553C21.5728 18.4762 21.9465 19.3257 22.681 20.0003C23.0139 20.3133 23.3856 20.5553 23.7992 20.7272C23.7095 20.9849 23.6148 21.2318 23.5142 21.4689ZM20.3987 9.32009C20.3987 10.1203 20.1037 10.8674 19.5157 11.5589C18.8061 12.381 17.9478 12.8561 17.0171 12.7811C17.0052 12.6851 16.9983 12.5841 16.9983 12.4779C16.9983 11.7097 17.3358 10.8876 17.9351 10.2155C18.2342 9.87514 18.6148 9.59215 19.0762 9.36641C19.5366 9.14404 19.9722 9.02106 20.3818 9C20.3937 9.10697 20.3987 9.21395 20.3987 9.32008V9.32009Z",
    fill: "black"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 33,
    height: 33,
    rx: 16.5,
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppleIcon);
export default __webpack_public_path__ + "static/media/AppleIcon.632f3f3c.svg";
export { ForwardRef as ReactComponent };